<mat-drawer-container>
	<mat-drawer #drawer mode="over">
		<ng-container *localVar="siteSettings$ | async as settings">
			<mat-toolbar>
				<div class="drawer-toolbar-nav" routerLink="/">
					<img [src]="settings?.organizationLogo?.data?.attributes?.url" [alt]="settings?.siteTitle" />
					<span class="name">{{ settings?.siteTitle }}</span>
				</div>
				<button mat-icon-button (click)="drawer.close()" aria-label="Close">
					<mat-icon>close</mat-icon>
				</button>
			</mat-toolbar>

			<mat-nav-list class="drawer-content">
				<div class="top-nav">
					<a mat-list-item routerLink="/" (click)="drawer.close()">Home</a>

					<a mat-list-item [href]="settings?.helpLink"
					   target="_blank" i18n="Help Link Text@@accountBarHelpLinkText"
					>Help</a
					>
				</div>
				<div class="footer-nav">
					<app-language-selector></app-language-selector>
					<a mat-list-item (click)="logout()" i18n="Log Out Link Text@@accountBarLogOutLinkText">Log Out</a>
				</div>
			</mat-nav-list>
		</ng-container>
	</mat-drawer>
	<mat-drawer-content class="project-drawer">
			<mat-toolbar class="project-toolbar">

				<ng-container *ngIf="state === projectState.AdStudio">
					<app-header class="toolbar-header" [navState]="navStateEnum.AD_STUDIO"></app-header>
				</ng-container>

				<ng-container *ngIf="state !== projectState.VideoBuilder && state !== projectState.AdStudio">
					<app-header [navState]="navStateEnum.SETTINGS"></app-header>
				</ng-container>

				<button mat-button
						*ngIf="state !== projectState.AdStudio && state !== projectState.VideoBuilder"
						class="hamburger-toggle"
						(click)="drawer.open()">
					<mat-icon>menu</mat-icon>
				</button>
			</mat-toolbar>


		<div class="page-loader" *ngIf="(loading$ | async)">
			<mat-spinner [diameter]="40"></mat-spinner>
			<p i18n="Loading Message@@projectPageLoadingProjectMessage">Loading Project...</p>
		</div>

		<ng-container *ngIf="(project$ | async) as project">
			<ng-container *ngIf="!!state && adStudioProjectLoaded">
				<ng-container *localVar="(project.version == '2') as adStudioProject">
					<!-- Ad Studio/Beta projects have version '2' -->
					<ng-container *localVar="projectCartItems$ | async as projectCartItems">
						<ng-container *localVar="(siteCopy$ | async) as siteCopy">
							<ng-container *ngIf="state !== projectState.AdStudio && state !== projectState.VideoBuilder">
								<div class="header no-background mb-5">
									<div class="back-container">
										<button
											data-cy="back-to-home"
											mat-flat-button
											color="tertiary"
											*ngIf="state === projectState.Project || state === projectState.Download"
											class="no-padding"
											(click)="goToHome()"
										>
											<mat-icon>chevron_left</mat-icon>
											<ng-container i18n="Back Button@@projectPageBackToButtonLabel">Back to</ng-container>&nbsp;<ng-container
											i18n="Home Label@@projectPageHomeLabel"
										>Home</ng-container
										>
										</button>
										<button
											mat-flat-button
											color="tertiary"
											*ngIf="state === projectState.ProjectCheckout || state === projectState.Settings || state === projectState.Export || (this.state === projectState.AddTemplate && projectCartItems.length > 0)"
											class="no-padding back-to-project-button"
											(click)="goBack(state)"
										>
											<mat-icon>chevron_left</mat-icon>
											<ng-container i18n="Back Button@@projectPageBackToButtonLabel">Back to</ng-container>
											<span class="back-to-project-name">{{project.name}}</span>
										</button>
									</div>

									<div class="title-row flex">
										<div class="left flex-grow">
											<h1 class="title mb-0">
												<ng-container *ngIf="state !== projectState.Settings">
													<ng-container *ngIf="state === projectState.ProjectCheckout"
													>{{siteCopy.projectPageCheckoutTitle}}:
													</ng-container>
													<ng-container *ngIf="state === projectState.Export && !isGuestUser" i18n="Title@@projectPageExportTitle"
													>Export:
													</ng-container>
													{{ project.name }}

													<mat-icon
														inline
														*ngIf="( siteSettings$ | async)?.disableExternalProjectLink === false && (state === projectState.Project || state === projectState.AddTemplate) && adStudioProject && !isGuestUser"
														class="cursor-pointer ml-2 project-settings"
														(click)="goToProjectSettings()"
													>settings</mat-icon
													>
												</ng-container>
												<ng-container *ngIf="state === projectState.Settings" i18n="Title@@projectPageSettingsTitle">
													Settings
												</ng-container>
											</h1>
										</div>
										<ng-container *ngIf="!isGuestUser">
											<div
												class="right ml-3 proceed-checkout-top"
												*ngIf="state === projectState.Project && !disableCheckout"
												[matTooltipDisabled]="!(!canPurchase ||!(project | transformObject: canCheckout: projectCartItems: this))"
												matTooltip="{{siteCopy.projectPageCheckoutDisabledTooltip}}"
											>
												<button
													class="round-border"
													mat-flat-button
													color="primary"
													#checkoutButton
													(click)="goToCheckout()"
													[disabled]="!canPurchase || !(project | transformObject: canCheckout: projectCartItems: this)"
												>
													<mat-icon inline>file_open</mat-icon>
													{{siteCopy.projectPageCheckoutButtonLabel}}
												</button>
											</div>
											<div
												class="right ml-3"
												*ngIf="state === projectState.ProjectCheckout && downloadReceiptEnabled && !disableReceiptButton"
											>
												<button mat-flat-button color="primary" class="round-border" (click)="downloadReceipt()">
													<mat-icon inline>download</mat-icon>
													<ng-container i18n="Download Receipt Button@@projectPageDownloadReceiptButtonLabel"
													>Download receipt</ng-container
													>
													<ng-container *ngIf="receiptLoading">
														<span class="gtb-loader small ml-4"></span>
													</ng-container>
												</button>
											</div>
											<ng-container
												*ngIf="adStudioProject && (state === projectState.Download || (state === projectState.Project && projectStateExportEnabled))"
											>
												<div class="right ml-3" *ngIf="!exportActive || (adminMode$ | async)">
													<button
														mat-flat-button
														color="primary"
														data-cy="export-cart-button"
														class="round-border export-cart-button"
														[disabled]="!(projectCartItems.length > 0)"
														(click)="goToExport()"
													>
														<mat-icon inline>file_open</mat-icon>
														<span i18n="Export Cart Button@@projectPageExportCartButtonLabel"
														>Export items</span
														>
													</button>
												</div>
											</ng-container>

											<mat-form-field class="no-label ml-4 project-status-select" appearance="fill" floatLabel="always" *ngIf="isProjectFinished && isSuperAdmin">
												<mat-label i18n="Project Status Change Label@@projectStatusChangeLabel">Change project status:</mat-label>
												<mat-select [value]="isProjectFinished ? ProjectStatus.Finished : ProjectStatus.Draft" (selectionChange)="changeProjectStatus($event)">
													<mat-option i18n="projectStatusDraftOption@@projectStatusDraftOption" [value]="ProjectStatus.Draft">Draft</mat-option>
													<mat-option i18n="projectStatusFinishedOption@@projectStatusFinishedOption" [value]="ProjectStatus.Finished">Finished</mat-option>
												</mat-select>
											</mat-form-field>
										</ng-container>
									</div>

									<div class="project-metadata">
										<span>{{ state === projectState.Settings ? project.name : project.business?.name }}</span>
									</div>
								</div>
							</ng-container>

							<!-- Project Details-->
							<div class="section-container project-details" *ngIf="state === projectState.Project">
								<div class="list-container content-group no-background">
									<ng-container *ngIf="adStudioProject && projectStateExportEnabled && !isGuestUser">
										<app-export-download
											class="mb-6"
											*ngIf="((activeProject$ | async)?.encodeJobs | filterArrayBy: 'tag': 'export')?.length > 0"
											(finishExportEvent)="finishExport()"
										></app-export-download>
									</ng-container>

									<div class="title-row flex align-center">
										<div class="left">
											<h2 class="title lg uppercase" i18n="Cart Items Title@@projectPageCartItemsTitle">Cart Items</h2>
										</div>
										<div *ngIf="!isGuestUser && adStudioProject" class="right">
											<button
												mat-flat-button
												color="primary"
												class="round-border add-template-cta"
												(click)="goToAddTemplate()"
												[disabled]="exportActive || (loading$ | async)"
											>
												<mat-icon>add</mat-icon>
												<span i18n="Add Template Button@@projectPageAddTemplateButtonLabel">Add Template</span>
											</button>
										</div>
									</div>
									<div class="content p-4 has-paginator scrollbar-thin project-cart-list" *ngIf="!adStudioProject">
										<ng-container
											*ngIf="project | transformObject: convertProjectStateToCartItems | arrayOrDefault as cartItems"
										>
											<app-cart-list
												[items]="cartItems"
												[mode]="projectConfig.mode"
												[showGroupActions]="false"
												(goToItem)="goToProjectVideoBuilder($event?.item)"
												(goToGroup)="goToProjectVideoBuilder()"
											></app-cart-list>
										</ng-container>
									</div>
									<div class="content p-4 has-paginator scrollbar-thin project-cart-list" *ngIf="adStudioProject">
										<ng-container *ngIf="projectCartItems | arrayOrDefault as cartItems else emptyCart">
											<app-cart-list
												[items]="cartItems"
												[mode]="projectConfig.mode"
												[showReview]="reviewEnabled"
												[actionInProgress]="actionInProgress"
												(goToItem)="goToItem($event?.item)"
												(goToGroup)="goToGroup($event)"
												(deleteItems)="deleteCartItems(project.id, $event.items, $event.mode)"
												(groupAction)="cartItemGroupAction($event)"
												(itemAction)="cartItemAction($event)"
											></app-cart-list>
										</ng-container>

										<ng-template #emptyCart>
											<div>
												<p class="m-2" i18n="Empty Cart Message@@projectPageEmptyCartMessage">No packages in the cart</p>
											</div>
										</ng-template>
									</div>

									<!-- Export history -->
									<div class="mt-6" *ngIf="(exportHistory$ | async)?.length && !isGuestUser">
										<div class="row flex align-center">
											<div class="left flex-grow">
												<h1 class="title gray lg uppercase m-0" i18n="Export History Title@@downloadPageExportHistoryTitle">
													Export history
												</h1>
											</div>
										</div>

										<div class="export-history mt-4">
											<app-export-history></app-export-history>
										</div>
									</div>

									<div>
										<button
											*ngIf="!disableCheckout && !isGuestUser"
											class="round-border"
											mat-flat-button
											color="primary"
											matTooltip="{{siteCopy.projectPageCheckoutDisabledTooltip}}"
											[matTooltipDisabled]="!(!canPurchase ||!(project | transformObject: canCheckout: projectCartItems: this))"
											[disabled]="!canPurchase || !(project | transformObject: canCheckout: projectCartItems: this)"
											(click)="goToCheckout()"
										>
											<mat-icon inline>file_open</mat-icon>
											{{ siteCopy.projectPageCheckoutButtonLabel }}
										</button>
									</div>
								</div>
							</div>

							<!-- Project Settings-->

							<div class="section-container project-settings" *ngIf="adStudioProject && state === projectState.Settings && !isGuestUser">
								<div class="list-container content-group no-background" *ngIf="activeProject$ | async as activeProject">
									<div class="title-row flex align-center">
										<div class="left">
											<h2 class="title xlg" i18n="Project Settings Section Title@@projectPageSettingsExternalLinksTitle">
												External creative package links
											</h2>
										</div>
										<div class="right">
											<button mat-flat-button color="primary" class="round-border" (click)="showExternalLinkDialog()">
												<mat-icon>add</mat-icon>
												<ng-container i18n="Add External Link Button@@projectPageAddExternalLinkButtonLabel"
												>Add external link</ng-container
												>
											</button>
										</div>
									</div>
									<div class="settings-container">
										<div class="content settings-item" *ngFor="let syncingProvider of activeProject.syncingProviders">
											<div class="icon">
												<img
													*ngIf="syncingProvider.dataSource.connectorType === DataSourceConnectorType.SmartSheet"
													src="./assets/icon/smartsheet.svg"
													alt="Smartsheet"
													i18n-alt="Smartsheet Icon@@projectPageSmartsheetIcon"
												/>
											</div>
											<div class="settings-details">
												<div class="name">{{syncingProvider.dataSource.name}}</div>
												<div>
													{{syncingProvider.dataSource.connectorType | titlecase}}:
													{{syncingProvider.dataSource.config.target}}
												</div>
												<div *ngIf="syncingProvider?.dataSource?.dataSourceLink">
													<span i18n="Datasource URL text@@projectPageDatasourceURLtext">URL</span>:
													<a href="{{syncingProvider.dataSource.dataSourceLink}}" target="_blank"
													>{{syncingProvider.dataSource.dataSourceLink}}</a
													>
												</div>
											</div>
											<div class="settings-actions">
												<div
													class="action uppercase text-white"
													(click)="showExternalLinkDialog(syncingProvider)"
													i18n="Manage Link Button@@projectPageManageLinkButtonLabel"
												>
													Manage link
												</div>
												<mat-icon color="warn" class="action" (click)="deleteExternalLink(syncingProvider)"
												>delete</mat-icon
												>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Checkout -->
							<app-checkout
								@fade
								*ngIf="state === projectState.ProjectCheckout"
								(onCheckoutClick)="goToDownload()"
								class="section-container"
							></app-checkout>

							<!-- Download -->
							<app-download @fade
										  [isGuestUser]="isGuestUser"
										  (goToProjectVideoBuilder)="goToProjectVideoBuilder()"
										  *ngIf="state === projectState.Download" class="section-container"></app-download>

							<!-- Export -->
							<ng-container *ngIf="state === projectState.Export">
								<app-export
									data-cy="export-root"
									@fade
									class="section-container"
									(onSubmit)="onCartJobSubmit($event); goBack(state);"
								></app-export>
							</ng-container>

							<!-- Add Package -->
							<ng-container *ngIf="state === projectState.AddTemplate">
								<div class="no-background scroll-container" *ngIf="!(loading$ | async)">
									<app-ad-package-add
										[project]="project"
										(selectVideoBuilder)="createVideoCartItem()"
										(selectedListing)="goToListing($event)"
										(selectedPartialListing)="addListingGroupToCart($event.group, $event.listing, $event.item)"
										(selectPackage)="goToAdPackage($event)"
										(customEvent)="onCustomEvent($event)"
										[enableNewCreativePackageRequests]="enableNewCreativePackageRequests"
									></app-ad-package-add>
								</div>
							</ng-container>

							<!-- Ad Studio View -->
							<ng-container *ngIf="state === projectState.AdStudio">
								<app-ad-studio-container
									[project]="project"
									[listing]="adStudioConfig.listing"
									[pkg]="adStudioConfig.package"
									[group]="adStudioConfig.group"
									[item]="adStudioConfig.item"
									[itemIds]="adStudioConfig.itemIds"
									[projectReviewState]="projectReviewState"
									(saved)="goToProjectState()"
									(back)="goToProjectState()"
									[enableNewCreativePackageRequests]="enableNewCreativePackageRequests"
									(customEvent)="onCustomEvent($event)"
								></app-ad-studio-container>
							</ng-container>

							<!-- Video Builder View -->
							<ng-container *ngIf="state === projectState.VideoBuilder">
								<app-video-builder
										*ngIf="adStudioProject"
										[cartItem]="videoBuilderConfig.cartItem"
										[isGuestUser]="isGuestUser"
										(backClicked)="goToProjectState()"
										(saveToProject)="goToProjectState(false)"
								></app-video-builder>
								<!-- Classic Project -->
								<app-video-builder
										*ngIf="!adStudioProject"
										[project]="project"
										[isGuestUser]="isGuestUser"
										(backClicked)="goToHome()"
										(checkoutClicked)="goToCheckout()"
								>
								</app-video-builder>
							</ng-container>
						</ng-container>
					</ng-container>
				</ng-container>
			</ng-container>
		</ng-container>

	</mat-drawer-content>
</mat-drawer-container>
